import { Button, Col, ComponentLoader, HorizontalRule, Modal, Row } from '@snsw/react-component-library';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../Page.module.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { saveApplication } from 'shared/redux/applicationSlice';
import { removePlantItem } from 'plantItemNew/redux/actions';

export const SaveOrCancelItem = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const application = useSelector((state) => state.application);
  const [showModal, setShowModal] = useState(false);

  const confirmDelete = () => {
    setShowModal(false);
    if (Number.isInteger(+props.index)) {
      dispatch(removePlantItem(parseInt(props.index)));
      dispatch(saveApplication(true));
    }

    navigate(PagePath.plantItemList);
  };

  const cancelDelete = () => {
    setShowModal(false);
  };

  return (
    <>
      <HorizontalRule />

      <Button variant="secondary" onClick={props.onSaveClick}>
        Save
      </Button>

      <Button
        className={styles.mobileSaveExitMargin}
        variant="tertiary"
        onClick={() => {
          setShowModal(true);
        }}
      >
        Cancel
      </Button>
      {showModal && (
        <Modal
          title="Are you sure you want to cancel adding this item?"
          description={'All details entered for this item will be deleted.'}
          buttons={[
            { text: 'Yes cancel', onClick: confirmDelete },
            { text: 'No continue', onClick: cancelDelete },
          ]}
        />
      )}

      {application.savingApplication && (
        <Row>
          <Col span={12}>
            <ComponentLoader fullPage />
          </Col>
        </Row>
      )}
    </>
  );
};

SaveOrCancelItem.propTypes = {
  onSaveClick: PropTypes.func.isRequired,
  index: PropTypes.string.isRequired,
};
